(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('cssPositionElmBased', cssPositionElmBased);

    function cssPositionElmBased(lodash, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                function cssPositionElmBasedResize(scope, elm, attrs) {
                    const elmInstance = elm[0];
                    const options = JSON.parse(attrs.cssPositionElmBased);

                    switch (options.position) {
                        case 'right': {
                            const position = options.position;
                            const offset = options.offset;
                            const elmOffsetWidth = elmInstance.offsetWidth;

                            elmInstance.style[position] = ((elmOffsetWidth - offset) * -1) + 'px';
                            break;
                        }
                        case 'left': {
                            const position = options.position;
                            const offset = options.offset;
                            const elmOffsetWidth = elmInstance.offsetWidth;

                            elmInstance.style[position] = ((elmOffsetWidth + offset) * -1) + 'px';
                            break;
                        }
                        case 'top': {
                            const position = options.position;
                            const offset = options.offset;
                            const elmOffsetHeight = elmInstance.offsetHeight;

                            elmInstance.style[position] = ((elmOffsetHeight + offset) * -1) + 'px';
                            break;
                        }
                    }
                }

                $timeout((function (scope, elm, attrs) {
                    return function() {
                        cssPositionElmBasedResize(scope, elm, attrs);
                    }
                })(scope, elm, attrs), 300);

                $(window).resize((function (scope, elm, attrs) {
                   return function() {
                       cssPositionElmBasedResize(scope, elm, attrs);
                   }
                })(scope, elm, attrs));
            },
        };
    }
})();